<template>
<div class="block-area-wrap">
  <el-tree
    :data="list"
    show-checkbox
    node-key="id"
    default-expand-all
    :expand-on-click-node="false">
    <span class="custom-tree-node" slot-scope="{ node, data }">
      <span>{{ node.label }}</span>
      <i class="el-icon-circle-plus" @click="append(data)"></i>
      <i class="el-icon-edit" @click="edit(data)" v-if="data.id !== 1"></i>
      <i class="el-icon-delete" @click="deleteZone(data)" v-if="data.id !== 1"></i>
    </span>
  </el-tree>
  <el-dialog
    title="添加"
    :visible.sync="dialogVisible"
    width="30%"
    :before-close="handleClose">
    <div class="block-form-wrap">
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="上级区域">
          <el-input v-model="form.parentZoneName"></el-input>
        </el-form-item>
        <el-form-item label="区域名称">
          <el-input v-model="form.zoneName"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="addZone">确 定</el-button>
    </span>
  </el-dialog>
</div>
</template>

<script>
import { getZoneLayerList, addZone, modifyZone, deleteZone } from '@/api/merchant-info'
export default {
  data () {
    return {
      form: {
        parentZoneName: '',
        zoneName: ''
      },
      dialogVisible: false,
      list: [],
      zoneList: [],
      parentNode: {},
      flag: false,
      loading: '',
      type: 1 // 1.新增 2.编辑
    }
  },
  created () {
    this.getZoneLayerList()
  },
  methods: {
    // 删除区域
    async deleteZone (rowInfo) {
      try {
        await this.$confirm('确认删除此区域？')
        const res = await deleteZone({
          id: rowInfo.id
        })
        if (res.error_code === '0') {
          this.$message.success('删除成功')
          this.getZoneLayerList()
        } else {
          this.$message.warning(res.error_msg)
        }
      } catch (e) {
        console.log(e)
      }
    },
    // 递归处理区域数组
    filterArray (list) {
      list.forEach(item => {
        item.label = item.zoneName
        item.children = item.subZoneList
        if (item.subZoneList && item.subZoneList.length > 0) {
          this.filterArray(item.subZoneList)
        }
      })
      this.list = list
    },
    // 获取地区列表
    async getZoneLayerList () {
      try {
        this.loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        const res = await getZoneLayerList()
        if (res.error_code === '0') {
          this.zoneList = res.data.zoneList
          const list = [res.data.zoneLayer]
          this.filterArray(list)
        } else {
          this.$message.error(res.error_msg)
        }
      } catch (e) {
        console.log(e)
      } finally {
        this.loading.close()
      }
    },
    async addZone (rowInfo) {
      try {
        this.loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        let res
        if (this.type === 1) {
          res = await addZone({
            parentZoneId: this.parentNode.id,
            zoneName: this.form.zoneName
          })
        }
        if (this.type === 2) {
          res = await modifyZone({
            parentZoneId: this.parentNode.parentZoneId,
            zoneName: this.form.zoneName,
            id: this.parentNode.id
          })
        }
        if (res.error_code === '0') {
          this.getZoneLayerList()
          this.$message.success(`${this.type === 1 ? '新增' : '编辑'}成功`)
          this.dialogVisible = false
        } else {
          this.$message.error(res.error_msg)
        }
      } catch (e) {
        console.log(e)
      } finally {
        this.loading.close()
      }
    },
    edit (data) {
      this.type = 2
      console.log(data)
      this.parentNode = data
      const parentZoneNameObj = this.zoneList.find(item => { return item.id === data.parentZoneId }) || {}
      this.form.parentZoneName = parentZoneNameObj.zoneName
      this.form.zoneName = data.zoneName
      this.dialogVisible = true
    },
    append (data) {
      this.parentNode = data
      this.type = 1
      this.form.zoneName = ''
      this.form.parentZoneName = data.zoneName
      this.dialogVisible = true
    },

    remove (node, data) {
      const parent = node.parent
      const children = parent.data.children || parent.data
      const index = children.findIndex(d => d.id === data.id)
      children.splice(index, 1)
    }
  }
}
</script>
<style lang="scss" scoped>
.block-area-wrap{
  margin:0 20px 20px 20px;
  padding:20px;
  background:#fff;
}
.el-icon-circle-plus{
  margin:0 0 0 20px;
  color:#409eff;
  font-size:20px;
}
.el-icon-edit{
  margin:0 0 0 10px;
  color:#409eff;
  font-size:20px;
}
.el-icon-delete{
  margin:0 0 0 10px;
  color:#409eff;
  font-size:20px;
}
</style>
